import { Phone, FileSearch, Building2, KeyRound } from "lucide-react";
import Reveal from "@/components/site/Reveal";

const steps = [
  {
    icon: Phone,
    title: "1. Hubungi Saya",
    desc: "Mulakan dengan WhatsApp atau isi borang. Ceritakan keperluan pinjaman rumah anda.",
  },
  {
    icon: FileSearch,
    title: "2. Semakan Dokumen",
    desc: "Saya bantu semak kelayakan & susun dokumen anda dengan selamat dan sulit.",
  },
  {
    icon: Building2,
    title: "3. Permohonan Bank",
    desc: "Permohonan dihantar ke bank paling sesuai untuk peluang kelulusan terbaik.",
  },
  {
    icon: KeyRound,
    title: "4. Kelulusan & Kunci",
    desc: "Setelah diluluskan, anda selangkah lebih dekat untuk memiliki rumah idaman.",
  },
];

export default function Process() {
  return (
    <section id="proses" data-testid="process-section" className="py-24 md:py-32 bg-[#F8F9FA] border-y border-slate-200">
      <div className="mx-auto max-w-7xl px-6">
        <Reveal>
          <div className="max-w-2xl">
            <span className="text-sm font-semibold uppercase tracking-wider text-[#1D4ED8]">
              Cara Ia Berfungsi
            </span>
            <h2 className="mt-3 text-3xl md:text-4xl font-extrabold tracking-tight text-[#0A2540]">
              4 langkah mudah ke arah rumah impian
            </h2>
            <p className="mt-4 text-slate-600 leading-relaxed">
              Proses yang jelas dan telus — anda sentiasa tahu di mana kedudukan
              permohonan anda pada setiap peringkat.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.1}>
              <div
                data-testid={`process-step-${i + 1}`}
                className="group h-full rounded-2xl bg-white border border-slate-200 p-7 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-transform duration-300 hover:-translate-y-1"
              >
                <div className="inline-flex rounded-xl bg-[#0A2540] p-3 transition-colors group-hover:bg-[#1D4ED8]">
                  <s.icon className="h-6 w-6 text-white" />
                </div>
                <h3 className="mt-5 font-heading text-lg font-bold text-[#0A2540]">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
